import React, { useEffect, useState } from "react";
import Scaffold from "../../widget/layouts/Scaffold";
import AppTranslation from "../app_translation/AppTranslation";
import pdfIcon from "../../assets/images/icons/pdf.png";
import fileIcon from "../../assets/images/icons/file.png";
import docIcon from "../../assets/images/icons/doc.png";
import FileDocumentPickerButtons from "./widget/FileDocumentPickerButtons";
import { useSelector } from "react-redux";
import { RootState } from "../../libraries/state_reducers/store";
import { docExtensions, pdfExtensions } from "../../const/FileExtensions";
import { ResponsiveDeviceType } from "../../widget/layouts/ScreenMedia";
import { ButtonSingle } from "../../widget/common/form/Button";
import { useDispatch } from "react-redux";
import { removeModal } from "../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../const/ModalKeys";
import { appplyActionDocument } from "../../libraries/state_reducers/service/FileDocumentPickerReducer";
import { Position } from "../../widget/common/ui/Stack";
import Center from "../../widget/common/ui/Center";
import Loader from "../../widget/common/ui/Loader";

const FileDocumentPickerScreen = (props: { screenMobileView: boolean }) => {
  const dispatch = useDispatch();
  const type: number = ResponsiveDeviceType();

  const [loading, setLoading] = useState(true);

  const fileDocumentDetailSelector = useSelector(
    (state: RootState) => state.fileDocumentPicker.fileDocumentDetail
  );

  const [document, setDocument] = useState<string | null>(null);
  const [documentExt, setDocumentExt] = useState<string | null>(null);

  const loaderHtml: JSX.Element = (
    <Position className="h-100 w-100" top={0} left={0} right={0}>
      <Center className="h-100 w-100">{Loader.normal()}</Center>
    </Position>
  );

  const applyDocumentDetail = () => {
    dispatch(appplyActionDocument(true));
    dispatch(removeModal(ModalKeys.file_document_viewer));
  };

  const handleLoaded = () => {
    setLoading(false);
  };

  const bodyContent: JSX.Element = (
    <div className={`"position-relative h-100 ${type === 3 ? "" : "d-center"}`}>
      <div
        style={{
          height:
            type === 3
              ? 430
              : pdfExtensions.includes(documentExt!)
              ? "100%"
              : "70%",
        }}
        className="bgcolor-grey w-100 d-center"
      >
        {pdfExtensions.includes(documentExt!) ? (
          <>
            {loading && loaderHtml}
            <iframe
              src={`${document}#toolbar=0&navpanes=0&scrollbar=0`}
              width="100%"
              style={{
                height: loading ? 0 : `100%`,
                opacity: loading ? 0 : 1,
              }}
              onLoad={() => handleLoaded()}
              title="preview"
            />
          </>
        ) : (
          <img
            src={
              pdfExtensions.includes(documentExt!)
                ? pdfIcon
                : docExtensions.includes(documentExt!)
                ? docIcon
                : fileIcon
            }
            className="h-100"
            alt=""
          />
        )}
      </div>

      {type === 3 && (
        <div className={`pt-3 ${type === 3 ? "d-center" : ""}`}>
          <ButtonSingle handleClick={() => applyDocumentDetail()} width={350}>
            {AppTranslation.text("send")}
          </ButtonSingle>
        </div>
      )}
    </div>
  );

  useEffect(() => {
    if (fileDocumentDetailSelector?.fileString != null) {
      setDocument(fileDocumentDetailSelector?.fileString);

      const ext = fileDocumentDetailSelector?.fileName
        .split(".")
        .pop()
        ?.toLowerCase();
      setDocumentExt(ext!);
    }
  }, [fileDocumentDetailSelector]);

  useEffect(() => {
    return () => {
      dispatch(appplyActionDocument(false));
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {document != null && (
        <>
          {props.screenMobileView === true ? (
            <Scaffold
              appBarTitle={AppTranslation.text("document")}
              isModal={true}
              bottomNavigationButton={<FileDocumentPickerButtons />}
            >
              {bodyContent}
            </Scaffold>
          ) : (
            bodyContent
          )}
        </>
      )}
    </>
  );
};

export default FileDocumentPickerScreen;
